export default __webpack_public_path__ + "static/media/beatskillz-sequel.08a2afa2.jpg";